import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

/** Sección a la que pertenece la pantalla (encabezado de la bandeja). */
const SECCION = 'Encefalopatía Espongiforme Bovina (EEB)';

/**
 * Sección de Encefalopatía Espongiforme Bovina. Un solo diagnóstico (RT52-71),
 * un solo ensayo —inmunocromatografía— y un solo formato (IHIMV-RT-21-EEB), así
 * que aporta una única pantalla: su bandeja y su hoja.
 */
export const eebRoutes: Routes = [
  {
    path: 'eeb/diagnostico',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Encefalopatía Espongiforme Bovina',
    data: {
      pantalla: 'EEB',
      breadcrumb: SECCION,
      titulo: 'Encefalopatía Espongiforme Bovina',
      permiso: Permiso.EEB_VER,
    },
  },
  {
    path: 'eeb/diagnostico/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'EEB',
      permiso: [Permiso.EEB_RESULTADOS, Permiso.EEB_VER],
    },
    loadComponent: () =>
      import('./pages/eeb-resultados/eeb-resultados.page').then(
        (m) => m.EebResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultado — EEB',
  },
];
